import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=73fcd854&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=73fcd854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fcd854",
  null
  
)

export default component.exports